import React from 'react';

/* Common */
import { Button, Icon } from '~/components/common';

/* Symbols */
import MarkerIcon from '~/../symbols/marker.svg';
import BusinessIcon from '~/../symbols/business.svg';
import ClockIcon from '~/../symbols/clock.svg';
import MoneyIcon from '~/../symbols/money.svg';

import { trans } from '~/utilities';

export default function CardVacancy({
    vacancy,
}) {
    const { overview_image, location, title, href, salary_min, salary_max, working_hours_min, working_hours_max, disciplines } = vacancy;

    return (
        <a href={href} className="card card--vacancy card--link text--sm text-decoration-none">
            <div className="card__header">
                <picture>
                    <source
                        srcSet={`${overview_image.formats["425x283"]} 1x, ${overview_image.formats["850x566"]} 2x`}
                        media="(min-width: 1660px)" />
                    <source
                        srcSet={`${overview_image.formats["313x209"]} 1x, ${overview_image.formats["626x418"]} 2x`}
                        media="(min-width: 1440px)" />
                    <source
                        srcSet={`${overview_image.formats["372x248"]} 1x, ${overview_image.formats["744x496"]} 2x`}
                        media="(min-width: 1280px)" />
                    <source
                        srcSet={`${overview_image.formats["285x190"]} 1x, ${overview_image.formats["570x380"]} 2x`}
                        media="(min-width: 992px)" />
                    <source
                        srcSet={`${overview_image.formats["320x213"]} 1x, ${overview_image.formats["640x426"]} 2x`}
                        media="(min-width: 768px)" />
                    <source
                        srcSet={`${overview_image.formats["356x237"]} 1x, ${overview_image.formats["712x474"]} 2x`}
                        media="(min-width: 600px)" />

                    <img
                        className="card__image img-fluid"
                        src={overview_image.formats["536x357"]}
                        srcSet={`${overview_image.formats["1072x714"]} 2x`}
                        width={536}
                        height={357}
                        alt={overview_image.title || "vacature"}
                        loading="lazy"
                    />
                </picture>
            </div>

            <div className="card-body d-flex flex-column">
                <p className="title h6">{title}</p>

                <div className="row flex-wrap gutters-0 gutters-md-1 mb-0 mb-md-2">
                    {location && (
                        <div className="col-12 col-md-6">
                            <span className="d-flex align-items-center gap-2">
                                <Icon size={16} url={MarkerIcon} />
                                <span className="text--12 text--md-16 text-truncate">{location}</span>
                            </span>
                        </div>
                    )}

                    {salary_min && salary_max && (
                        <div className="col-12 col-md-6">
                            <span className="d-flex align-items-center gap-2">
                                <Icon size={16} url={MoneyIcon} />
                                <span className="text--12 text--md-16">
                                    {parseFloat(salary_min).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} - {parseFloat(salary_max).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                </span>
                            </span>
                        </div>
                    )}

                    {(working_hours_min || working_hours_max) && (
                        <div className="col-12 col-md-6">
                            <span className="d-flex align-items-center gap-2">
                                <Icon size={16} url={ClockIcon} />
                                <span className="text--12 text--md-16">
                                    {working_hours_min && working_hours_max && `${working_hours_min} uur - ${working_hours_max} uur`}
                                    {working_hours_min && !working_hours_max && `${working_hours_min} uur`}
                                    {!working_hours_min && working_hours_max && `${working_hours_max} uur`}
                                </span>
                            </span>
                        </div>
                    )}

                    {disciplines?.length > 0 && (
                        <div className="col-12 col-md-6">
                            <span className="d-flex align-items-center gap-2">
                                <Icon size={16} url={BusinessIcon} />
                                <span className="text--12 text--md-16 text-capitalize">{disciplines[0]}</span>
                            </span>
                        </div>
                    )}
                </div>

                <div className="d-none d-md-flex mt-auto justify-content-between align-self-end">
                    <Button
                        className="btn-sm"
                        theme="outline-base"
                        title={trans('app.vacancy_overview.detail_button')}
                        href={href}
                        showIcon={false}
                    />
                </div>
            </div>
        </a>
    );
}
